module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"you-use-ie":"Vous consultez ce site avec Microsoft Internet Explorer <b>mais celui-ci n\u0027est pas capable d\u0027afficher correctement son contenu !</b><br />Merci d\u0027utiliser <b>Firefox</b>, <b>Chrome</b> ou <b>Edge</b>."}}')
  delete Component.options._Ctor
}
